var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.dummyKey,ref:"skillbox",staticStyle:{"display":"grid","grid-template-columns":"33% 33% 33%","justify-content":"space-between"},on:{"change":_vm.change}},_vm._l((_vm.skills),function(skill,index){return _c('div',{key:index},[_c('mdb-input',{attrs:{"type":"checkbox","name":skill,"id":skill,"label":skill}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }